import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';
import { rcmQueryKeys, type RcmAllTableParams } from '../../queries/rcm/keys.ts';
import { fetchRcmAllTablePage } from '../../request/rcm/functional.js';

export type RcmAllTablePageView = Awaited<ReturnType<typeof fetchRcmAllTablePage>>;

export function useRcmAllTablePage(listParams: RcmAllTableParams): UseQueryResult<RcmAllTablePageView, Error> {
  return useQuery({
    queryKey: rcmQueryKeys.allTable(listParams),
    queryFn: () => fetchRcmAllTablePage(listParams),
    placeholderData: keepPreviousData,
  });
}
